$(document).ready(function() {
  
  $('.site-credits-link').on('click',function(e){
    e.preventDefault();
    $('.site-credits').slideToggle();
    $('html, body').animate({scrollTop:$(document).height()},'slow');
  })
  
  if ( $('body.template-product .flexslider').length ) {
    
     $('.flexslider').flexslider({
    directionNav: false,
    controlNav: true,
    keyboardNav: true,
    slideshowSpeed: 5000,
    animation: "fade",
    prevText: 'Previous',
    nextText: 'Next',
      smoothHeight: false
  	});
    
    
  }
  
   if ( $('body.template-page .flexslider').length ) {
    
     $('.flexslider').flexslider({
    directionNav: false,
    controlNav: true,
    keyboardNav: true,
    slideshowSpeed: 5000,
    animation: "slide",
    prevText: 'Previous',
    nextText: 'Next',
      smoothHeight: true
  	});
    
    
  }
  
  
  
   if ( $('.testimonialsslider').length ) {
    
     $('.testimonialsslider').flexslider({
    directionNav: false,
    controlNav: true,
    keyboardNav: true,
    slideshowSpeed: 8000,
       pauseOnHover: true,
    animation: "slide",
    prevText: 'Previous',
    nextText: 'Next',
      smoothHeight: true
  	});
    
    
  }
  
  
  $('ul.tabs').each(function(){
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $links = $(this).find('a');

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');

    $content = $($active[0].hash);

    // Hide the remaining content
    $links.not($active).each(function () {
      $(this.hash).hide();
    });

    // Bind the click event handler
    $(this).on('click', 'a', function(e){
      // Make the old tab inactive.
      $active.removeClass('active');
      $content.hide();

      // Update the variables with the new link and content
      $active = $(this);
      $content = $(this.hash);

      // Make the tab active.
      $active.addClass('active');
      $content.show();

      // Prevent the anchor's default click action
      e.preventDefault();
    });
  });
  
  
   $('form#mc-embedded-subscribe-form-footer input#mc-embedded-subscribe').bind('click', function ( event ) {
            if ( event ) event.preventDefault();
        
			mailchimpSignup( $('form#mc-embedded-subscribe-form-footer'), $('.subMessagesubscriptionFormFooter') ); 
        });
  
  
  $('.search-trigger').on('click',function() {    
    $('.hidden-search-bar').slideToggle(); 
	$('input[name=q]').focus();
    $("html, body").animate({scrollTop:0},"slow");
  })
  var liwidth=0;
  $('ul.site-nav li').each(function() {
 	liwidth += $(this).outerWidth();
	});
  $('form.search-bar input[type=search]').width( liwidth+16 ); 
  
  $('.mobile-nav-icon').on('click',function() {
  	$('ul.site-nav').slideToggle();  
  })
  
  $('.social-sharing-trigger').on('click',function() {    
    $('.social-sharing a').slideToggle('medium', function() {
       if ($(this).is(':visible'))
        $(this).css('display','inline-block');
    }); 
  })
  
  
})




var $errorCount=0;

function mailchimpSignup($form, $responseContainer) {
  console.log('form submit / input: ' + $('input#mce-EMAIL').val() );
    jQuery.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later. "+$form.attr('action')); },
        success     : function(data) {
          
          console.log('data.msg: ' + data.msg);
            if (data.result != "success") {
				$errorCount++;
              	$dataMsg = data['msg'];
				if ( $dataMsg.indexOf('is already subscribed')>-1 ) {
					$returnMsg = "Email is already subscribed.";
				} else {
				switch ($dataMsg) {
					case '0 - The domain portion of the email address is invalid (the portion after the @: )',
						 '0 - The username portion of the email address is invalid (the portion before the @: )',
						 '0 - This email address looks fake or invalid. Please enter a real email address',
					     '0 - An email address must contain a single @',
						 '0 - Please enter a value' : 
					$returnMsg = "Please enter a real email address.";
        				break;
					
					default: $returnMsg = "Please try again.";
				}
				}
				if ($errorCount>1) $returnMsg = "Please try again.";
				if ($errorCount>2) $returnMsg = "And... please try again";
				if ($errorCount>3) {
					$returnMsg = "Sorry, Please try again.";
					$errorCount=0;
				}
				
				$responseContainer.html($returnMsg);
            } else {
				$responseContainer.html('Thank you! Please check your email for a confirmation&nbsp;message.');
            }
        }
    });
}

